import React, { Component } from 'react'
import { timezonesList } from 'cogsworth/utils/dates'
import { translate } from "react-i18next"
import { connect } from 'react-redux'
import Select, { createFilter } from 'react-select'

import { setTimezone } from 'cogsworth/utils/store'
import './TimezonePicker.css'

class TimezonePicker extends Component {
  constructor(props){
    super(props)

    this.timezonesList = timezonesList(props.timeStandard)
  }

  render() {
    const { dispatch, t, timezone } = this.props

    return (
      <div className={`timezone-picker top-option ${this.props.hidden ? 'hidden' : ''}`}>
        <span>{ t('timezone') }</span><br />
        <Select
          name="timezone"
          value={this.timezonesList.find((t) => { return t.value === timezone })}
          options={this.timezonesList}
          onChange={({ value }) => dispatch(setTimezone(value))}
          isSearchable
          filterOption={createFilter({ ignoreAccents: false })} // improves performance
          menuShouldScrollIntoView={false}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({ timezone: state.timezone })
export default connect(mapStateToProps)(translate("translations")(TimezonePicker))
